import { graphql } from 'react-relay';

export const lookupUser = graphql`
  query lookupUserQuery {
    bznavRefund {
      user {
        indis {
          id
          refundId
          refundAmount
          businessInfo {
            taxpayerName
          }
          partnerInfo {
            discountRate
          }
        }
        previousIndis {
          id
        }
        tritxIndis {
          refundStatus
          id
          refundAmount
          tritxReSearchRequestId
          businessInfo {
            taxpayerName
          }
          partnerInfo {
            discountRate
          }
        }
        corps {
          id
          refundId
          refundAmount
          businessInfo {
            hometaxBizName
          }
          partnerInfo {
            discountRate
          }
        }
      }
    }
  }
`;
